import { render, staticRenderFns } from "./BuildingChecklist.vue?vue&type=template&id=4536e202&scoped=true&"
import script from "./BuildingChecklist.vue?vue&type=script&lang=js&"
export * from "./BuildingChecklist.vue?vue&type=script&lang=js&"
import style0 from "./BuildingChecklist.vue?vue&type=style&index=0&id=4536e202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536e202",
  null
  
)

export default component.exports